module.exports = function (shopper) {
    return {
        event: 'login',
        ecommerce: {},
        shopper: {
            Id: shopper.Id,
            ABN: shopper.ABN,
            OrderCount: shopper.OrderCount,
        },
    };
};



// WEBPACK FOOTER //
// ./src/auth/login/login-analytics-mapper.js